import {Col, Row} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import React from "react";
import {NFTextInput} from "src/components/Shared/NewForms/NFTextInput";
import {NFTextAreaInput} from "src/components/Shared/NewForms/NFTextAreaInput";
import {NFCheckBoxInput} from "src/components/Shared/NewForms/NFCheckBoxInput";
import {NFDateInput} from "src/components/Shared/NewForms/NFDateInput";
import {FormProvider, useForm, useFormContext} from "react-hook-form";

export const PurchaseOrderDetailAdditional = () => {
    const {t} = useTranslation();
    const {watch, ...methods} = useFormContext();

    return (
        <>
            <Row>
                <Col sm={6}>
                    <NFTextAreaInput fieldName={"comment"} title={t("Comment")}/>
                </Col>
                <Col sm={6}>
                    <NFCheckBoxInput
                        title={t("PriceIncludesVAT")}
                        fieldName={"priceIncludesVat"}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFTextInput
                        title={t("CreatedUser")}
                        fieldName={"createdUser"}
                        disabled={true}
                    />
                </Col>
                <Col sm={6}>
                    <NFDateInput
                        title={t("CreatedDate")}
                        fieldName={"createdDate"}
                    />
                </Col>
            </Row>
        </>
    );
};
